import Vue from 'vue';
import i18n from '@/i18n';

// vee-validate
import { ValidationObserver, ValidationProvider, extend, localize, configure } from 'vee-validate';
import en from 'vee-validate/dist/locale/en.json';
// import th from 'vee-validate/dist/locale/th.json';
import * as rules from 'vee-validate/dist/rules';
// import i18n from './i18n';

// install rules and localization
Object.keys(rules).forEach((rule) => {
  extend(rule, rules[rule]);
});

extend('odd', {
  validate: (value) => {
    return value % 2 !== 0;
  },
  message: 'This field must be an odd number',
});

extend('unique', {
  validate: (value, list) => {
    // console.log(value, list)
    const name = value ? value.toLowerCase() : '';
    return !list.find((x) => x.name.toLowerCase() === name);
  },
  message: 'This value is duplicated!',
});

extend('unique-other', {
  params: ['list', 'oldValue'],
  validate: (value, { list, oldValue }) => {
    // console.log(list)
    // console.log(oldValue)
    const name = value ? value.toLowerCase() : '';
    const oldName = oldValue ? oldValue.toLowerCase() : '';
    if (oldName === name) {
      // console.log('no changed')
      return true;
    } else {
      return !list.find((x) => x.name.toLowerCase() === name);
    }
  },
  message: '{_field_} is duplicated!',
});

extend('unique-lastname', {
  validate: (value, list) => {
    // console.log(value, list)
    const name = value ? value.toLowerCase() : '';
    return !list.find((x) => x.last_name.toLowerCase() === name);
  },
  message: 'This last name is duplicated!',
});

extend('not-special', {
  validate: (value) => {
    const format = /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;
    return !format.test(value);
  },
  message: 'This value must not contain any special characters!',
});

extend('max-files', {
  validate: (value, maxFiles) => {
    // console.log(value, list)
    return value.length <= maxFiles;
  },
  message: 'You can not upload more than 10 documents at one time',
});

extend('sp-ext', {
  ...rules.ext,
  message: "The {_field_}'s extension must be bmp, gif, jpg, png, doc, docx, xls, xlsx, ppt, pptx, pdf, odt, txt, text, rtf, zip",
});

extend('sp-size', {
  ...rules.size,
  message: 'The {_field_} field size must be less than 20MB',
});

//vee-validate custom by best

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('validationObserver', ValidationObserver);

Object.keys(rules).forEach((rule) => {
  extend(rule, rules[rule]);
});

configure({
  classes: {
    valid: 'is-valid',
    invalid: 'is-invalid',
    dirty: ['is-dirty', 'is-dirty'], // multiple classes per flag!
    // ...
  },
});

// extend('required', {
//     ...rules.required,
//     message: i18n.t('menu.home'), // แก้ไขบรรทัดนี้
//   });

extend('required', {
  ...rules.required,
  message: 'Please fill the {_field_}',
});

extend('maxNumber', {
  validate: (value, { maxValue }) => {
    return value <= maxValue; // Validate that value does not exceed maxValue
  },
  params: ['maxValue'],
  message: 'The {_field_} field may not be greater than {maxValue}',
});

extend('no-emoji', {
  validate: (value) => {
    const emojiRegex =
      /([\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{1F700}-\u{1F77F}]|[\u{1F780}-\u{1F7FF}]|[\u{1F800}-\u{1F8FF}]|[\u{1F900}-\u{1F9FF}]|[\u{1FA00}-\u{1FA6F}]|[\u{1FA70}-\u{1FAFF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]|[\u{2300}-\u{23FF}]|[\u{2B50}]|[\u{1F004}]|[\u{1F0CF}]|[\u{1F170}-\u{1F171}]|[\u{1F17E}-\u{1F17F}]|[\u{1F18E}]|[\u{1F191}-\u{1F19A}]|[\u{1F1E6}-\u{1F1FF}]|[\u{1F201}-\u{1F202}]|[\u{1F21A}]|[\u{1F22F}]|[\u{1F232}-\u{1F23A}]|[\u{1F250}-\u{1F251}]|[\u{1F300}-\u{1F320}]|[\u{1F32D}-\u{1F335}]|[\u{1F337}-\u{1F37C}]|[\u{1F37E}-\u{1F393}]|[\u{1F3A0}-\u{1F3CA}]|[\u{1F3CF}-\u{1F3D3}]|[\u{1F3E0}-\u{1F3F0}]|[\u{1F3F4}]|[\u{1F3F8}-\u{1F43E}]|[\u{1F440}]|[\u{1F442}-\u{1F4FC}]|[\u{1F4FF}-\u{1F53D}]|[\u{1F54B}-\u{1F54E}]|[\u{1F550}-\u{1F567}]|[\u{1F57A}]|[\u{1F595}-\u{1F596}]|[\u{1F5A4}-\u{1F5A5}]|[\u{1F5A8}]|[\u{1F5B1}-\u{1F5B2}]|[\u{1F5BC}]|[\u{1F5C2}-\u{1F5C4}]|[\u{1F5D1}-\u{1F5D3}]|[\u{1F5DC}-\u{1F5DE}]|[\u{1F5E1}]|[\u{1F5E3}]|[\u{1F5E8}]|[\u{1F5EF}]|[\u{1F5F3}]|[\u{1F5FA}]|[\u{1F5FB}-\u{1F5FF}]|[\u{1F600}-\u{1F606}]|[\u{1F609}-\u{1F60D}]|[\u{1F60F}]|[\u{1F612}-\u{1F614}]|[\u{1F616}]|[\u{1F618}-\u{1F61A}]|[\u{1F61C}-\u{1F61E}]|[\u{1F620}-\u{1F625}]|[\u{1F628}-\u{1F62B}]|[\u{1F62D}]|[\u{1F630}-\u{1F633}]|[\u{1F635}-\u{1F640}]|[\u{1F645}-\u{1F64F}]|[\u{1F680}-\u{1F6C5}]|[\u{1F6CB}-\u{1F6D2}]|[\u{1F6E0}-\u{1F6E5}]|[\u{1F6E9}]|[\u{1F6EB}-\u{1F6EC}]|[\u{1F6F0}]|[\u{1F6F3}]|[\u{1F910}-\u{1F918}]|[\u{1F919}-\u{1F91E}]|[\u{1F920}-\u{1F927}]|[\u{1F928}-\u{1F92F}]|[\u{1F930}-\u{1F939}]|[\u{1F93C}-\u{1F93E}]|[\u{1F940}-\u{1F945}]|[\u{1F947}-\u{1F94C}]|[\u{1F950}-\u{1F95E}]|[\u{1F980}-\u{1F984}]|[\u{1F985}-\u{1F991}]|[\u{1F9C0}]|[\u{1F9C1}-\u{1F9C2}]|[\u{1F9E7}-\u{1F9FF}]|[\u{1FA70}-\u{1FA73}]|[\u{1FA78}-\u{1FA7A}]|[\u{1FA80}-\u{1FA82}]|[\u{1FA90}-\u{1FA95}]|[\u{1F004}]|[\u{1F0CF}]|[\u{1F18E}]|[\u{1F191}-\u{1F19A}]|[\u{1F1E6}-\u{1F1FF}]|[\u{1F201}-\u{1F202}]|[\u{1F21A}]|[\u{1F22F}]|[\u{1F232}-\u{1F23A}]|[\u{1F250}-\u{1F251}]|[\u{1F300}-\u{1F321}]|[\u{1F324}-\u{1F393}]|[\u{1F396}-\u{1F397}]|[\u{1F399}-\u{1F39B}]|[\u{1F39E}-\u{1F3F3}]|[\u{1F3F5}]|[\u{1F3F7}-\u{1F43F}]|[\u{1F441}]|[\u{1F444}-\u{1F4FC}]|[\u{1F4FF}-\u{1F53D}]|[\u{1F54B}-\u{1F54E}]|[\u{1F550}-\u{1F567}]|[\u{1F57A}]|[\u{1F595}-\u{1F596}]|[\u{1F5A4}-\u{1F5A5}]|[\u{1F5A8}]|[\u{1F5B1}-\u{1F5B2}]|[\u{1F5BC}]|[\u{1F5C2}-\u{1F5C4}]|[\u{1F5D1}-\u{1F5D3}]|[\u{1F5DC}-\u{1F5DE}]|[\u{1F5E1}]|[\u{1F5E3}]|[\u{1F5E8}]|[\u{1F5EF}]|[\u{1F5F3}]|[\u{1F5FA}]|[\u{1F5FB}-\u{1F5FF}]|[\u{1F600}-\u{1F64F}]|[\u{1F680}-\u{1F6C5}]|[\u{1F6CB}-\u{1F6D2}]|[\u{1F6E0}-\u{1F6E5}]|[\u{1F6E9}-\u{1F6EC}]|[\u{1F6F0}]|[\u{1F6F3}]|[\u{1F910}-\u{1F918}]|[\u{1F919}-\u{1F91E}]|[\u{1F920}-\u{1F927}]|[\u{1F928}-\u{1F92F}]|[\u{1F930}-\u{1F939}]|[\u{1F93C}-\u{1F93E}]|[\u{1F940}-\u{1F945}]|[\u{1F947}-\u{1F94C}]|[\u{1F950}-\u{1F95E}]|[\u{1F980}-\u{1F984}]|[\u{1F985}-\u{1F991}]|[\u{1F9C0}]|[\u{1F9E7}-\u{1F9FF}]|[\u{1FA70}-\u{1FA73}]|[\u{1FA78}-\u{1FA7A}]|[\u{1FA80}-\u{1FA82}]|[\u{1FA90}-\u{1FA95}])/u;

    return !emojiRegex.test(value) || `${i18n.t('veevalidate-message.no-emoji')}`;
  },
});

localize('en', en);

// Install components globally
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);
